import { postAccessibilityReport } from '@/services/accessibility-report-form.service'
import { Store, ActionContext as VueActionContext } from 'vuex'

export const NAMESPACE = 'accessibility-report-form'

export enum Property {
  Loading = 'loading',
  Exception = 'exception',
  SubmitForm = 'submitForm',
  IsFormSent = 'isFormSent',
}

type State = {
  [Property.Loading]: boolean;
  [Property.Exception]: boolean;
  [Property.IsFormSent]: boolean;
}

const namespaced = (getter: Property): string => `${NAMESPACE}/${getter}`

type AccessibilityReportFormStoreType = Store<State>

export const getLoading = (store: AccessibilityReportFormStoreType): boolean => store.getters[namespaced(Property.Loading)]
export const getException = (store: AccessibilityReportFormStoreType): boolean => store.getters[namespaced(Property.Exception)]
export const getIsFormSent = (store: AccessibilityReportFormStoreType): boolean => store.getters[namespaced(Property.IsFormSent)]

export const submitAccessibilityReportForm = (store: AccessibilityReportFormStoreType, request: string): Promise<void> => store.dispatch(namespaced(Property.SubmitForm), request)

export type ActionContext = VueActionContext<State, {}>

const AccessibilityReportFormStore = {
  namespaced: true,
  state: {
    [Property.Loading]: false,
    [Property.Exception]: false,
    [Property.IsFormSent]: false
  },
  getters: {
    [Property.Loading]: (state: State) => state[Property.Loading],
    [Property.Exception]: (state: State) => state[Property.Exception],
    [Property.IsFormSent]: (state: State) => state[Property.IsFormSent]
  },
  mutations: {
    [Property.Loading]: (state: State, loading: boolean) => state[Property.Loading] = loading,
    [Property.Exception]: (state: State, exception: boolean) => state[Property.Exception] = exception,
    [Property.IsFormSent]: (state: State, isFormSent: boolean) => state[Property.IsFormSent] = isFormSent
  },
  actions: {
    [Property.SubmitForm]: async ({ commit }: VueActionContext<State, {}>, request: string) => {
      try {
        commit(Property.Loading, true)
        commit(Property.Exception, false)

        await postAccessibilityReport(request)

        commit(Property.IsFormSent, true)
      } catch (err) {
        commit(Property.Exception, true)
      } finally {
        commit(Property.Loading, false)
      }
    }
  }
}

export default AccessibilityReportFormStore
